import React, { Component, createContext } from 'react';

export const DraftContext = createContext();

export class DraftProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drafts: {} // { chatId: 'draft message text' }
        };
    }

    saveDraft = (chatId, message) => {
        this.setState(prevState => ({
            drafts: {
                ...prevState.drafts,
                [chatId]: message
            }
        }));
    };

    getDraft = (chatId) => {
        return this.state.drafts[chatId] || '';
    };

    clearDraft = (chatId) => {
        this.setState(prevState => {
            const newDrafts = { ...prevState.drafts };
            delete newDrafts[chatId];
            return { drafts: newDrafts };
        });
    };

    render() {
        return (
            <DraftContext.Provider
                value={{
                    saveDraft: this.saveDraft,
                    getDraft: this.getDraft,
                    clearDraft: this.clearDraft,
                }}
            >
                {this.props.children}
            </DraftContext.Provider>
        );
    }
}